module.exports = __webpack_public_path__ + "img/chair1.49f15d55.png";